import { Component } from "@angular/core";
import { NavController } from "ionic-angular";
import { Storage } from "@ionic/storage";
//FODEL-DRIVER-MANAGER-APP
import { DriverListPage } from "../../dvm/driver/list/index";
import { AreaListPage } from "../../dvm/area/list/index";
import { ClientListPage } from "../../dvm/clients/list/index";
import { DriverMapPage } from "../../dvm/driver/map/index";

//FODEL-WAREHOUSE-MANAGER-APP
import { WhIndexPage } from "../../wh/index/index";

//BACKOFFICE PAGES//
import { WhSummaryPage } from "../../backoffice/overall/summary/index";
import { DvSummaryPage } from "../../backoffice/driver/summary/index";
import { AreaSummaryPage } from "../../backoffice/area/summary/index";
import { WhActionHistoryPage } from "../../backoffice/overall/history/index";
import { WhActiveParcelsSummaryPage } from "../../backoffice/overall/active_parcels/index";
import { EcommerceDashboard } from "../..//backoffice/ecomerce/dashboard/dashboard";

//FODEL-QUICK-DASHBOARAD
import { SearchParcel } from "../../qdb/search-parcel/index";
import { ParcelDashboard } from "../../qdb/parcel-dashboard/index";
import { DriverDashboard } from "../../qdb/driver-dashboard/index";
import { TicketsPage } from "./../../backoffice/tickets/index";

//AUTH SERVICE//

import { AuthService } from "../../../providers/auth-service";
import { EcommercePage } from "../../backoffice/ecomerce/ecomerce";
import { CollectionPointPage } from "../../backoffice/collecion-points";
import { ProfileInformationPage } from "../../backoffice/profile-information";
import { RTOHoldList } from "../../backoffice/rto-hold-list";
import { AddSitesPage } from "../../backoffice/add-sites";
import { CreateDHLShipment } from "../../backoffice/create-dhl-shipment";

@Component({
  selector: "custom-sidebar",
  templateUrl: "custom-sidebar.html"
})
export class CustomSidebarComponent {
  pages: Array<{ title: string; component: any }>;
  activePage: any;

  constructor(
    public navCtrl: NavController,
    private storage: Storage,
    private auth: AuthService
  ) {
    //setInterval(this.loadPages(), 3000);
    //setInterval(() => this.loadPages(), 3000);
    this.loadPages();
  }

  loadPages() {
    this.pages = [];
    let userInfo = JSON.parse(localStorage.getItem("userInfoData"));
    if (userInfo && userInfo.currency == "SAR") {
      this.pages.push({ title: "Profile", component: ProfileInformationPage });
      this.pages.push({ title: "Search Parcel", component: SearchParcel });
      this.pages.push({ title: "Search Site", component: CollectionPointPage });
      this.pages.push({ title: "Add New Sites", component: AddSitesPage });
    } else {
      this.pages.push({ title: "Profile", component: ProfileInformationPage });
      this.pages.push({ title: "Transfer Shipment", component: SearchParcel });
      this.pages.push({ title: "Search Site", component: CollectionPointPage });
      this.pages.push({
        title: "Change Timing",
        component: CollectionPointPage
      });
      this.pages.push({ title: "Add Sites", component: AddSitesPage });
      this.pages.push({ title: "Hold Parcels", component: RTOHoldList });
      this.pages.push({ title: "Create DHL Shipment", component: CreateDHLShipment });
    }

    // this.pages.push({ title: 'Driver List', component: DriverListPage });
    // this.pages.push({ title: 'Clients List', component: ClientListPage });
    // this.pages.push({ title: 'Warehouse', component: WhIndexPage });
    // this.pages.push({ title: 'Parels Dashboard', component: ParcelDashboard });
    // this.pages.push({ title: 'Driver Dashboard', component: DriverDashboard });

    //TicketsPage

    //         this.auth.get_menu_items().then((data:AjaxResponse)=>{

    //              if(data.code==1001)
    //                 {

    //                   for(var i = 0; i < data.data.length; i++) {
    //                         console.log('item '+i);

    //                   if(data.data[i].key=="summary")
    //                   {
    //                     this.pages.push({ title: data.data[i].value, component: WhSummaryPage });
    //                   }

    //                   if(data.data[i].key=="drivers")
    //                   {
    //                     this.pages.push({ title: data.data[i].value, component: DvSummaryPage });
    //                   }

    //                   if(data.data[i].key=="areas")
    //                   {
    //                     this.pages.push({ title: data.data[i].value, component: AreaSummaryPage });
    //                   }

    //                   if(data.data[i].key=="cod")
    //                   {
    //                    this.pages.push({ title: data.data[i].value, component: SearchParcel });
    //                   }

    //                   if(data.data[i].key=="byCreatedDate")
    //                   {
    //                     this.pages.push({ title: data.data[i].value, component: SearchParcel });
    //                   }

    //                   if(data.data[i].key=="search")
    //                   {
    //                     this.pages.push({ title: data.data[i].value, component: SearchParcel });
    //                   }

    //                   if(data.data[i].key=="activeParcels")
    //                   {
    //                     this.pages.push({ title: data.data[i].value, component: WhActiveParcelsSummaryPage });
    //                   }

    //                   if(data.data[i].key=="history")
    //                   {
    //                     this.pages.push({ title: data.data[i].value, component: WhActionHistoryPage });
    //                   }

    //                   }

    //                   this.pages.push({ title:'Map', component: DriverMapPage });
    //                   this.pages.push({title:'Ecommerces',component:EcommercePage});
    //                   this.pages.push({title:'Client Dashboard',component:EcommerceDashboard});
    //                   this.pages.push({title:'Parcels Dashboard',component:ParcelDashboard});
    //                   this.pages.push({title:'Driver Dashboard',component:DriverDashboard});

    //                }

    //         }).catch(e => {
    //     console.log('error='+e);
    // });
  }

  pushPage(title, page) {
    this.pages.push({ title: title, component: page });
  }

  openPage(page) {
    console.log(this.pages);
    this.navCtrl.push(page.component);
    this.activePage = page;
  }

  checkActviePage(p) {
    return p == this.activePage;
  }
}



// WEBPACK FOOTER //
// ./src/pages/common/sidebar/custom-sidebar.ts